<div class="park-use">
  @if (donutValues().length) {
    <button class="park-use_donut" (click)="clickDonut()">
      <donut globalValue="{{ usagePercentage }}%" [values]="donutValues()" />
    </button>
  }
  <div class="park-use_select">
    <p class="select_label">
      @if (dataGraph()?.label) {
        {{ 'STATE.STATUS' | translate: { value: dataGraph().label } }}
      } @else {
        {{ 'STATE.GLOBAL' | translate }}
      }
    </p>
    @if (isEdit) {
      <mat-form-field appearance="outline" color="primary" subscriptSizing="dynamic">
        <mat-label>{{ optionsTime[time()] }}</mat-label>
        <mat-select [ngModel]="time()" (ngModelChange)="updateCount($event)">
          @for (timeOp of optionsTime | keyvalue; track timeOp) {
            <mat-option [value]="timeOp.key">
              {{ timeOp.value }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    } @else {
      <p>{{ optionsTime[time()] }}</p>
    }
  </div>
</div>
<div [class.park-kpis]="!displayInline()" [class.park-kpis--inline]="displayInline()">
  @for (status of statusNumber | keyvalue: originalOrder; track status) {
    <status-card
      [style.flex]="1"
      [label]="'DEVICE.STATUS.' + status.key | translate"
      [value]="status.value"
      [percentage]="statusPercentage[status.key]"
      [color]="STATUS_COLOR[status.key]"
      [selected]="selectedStatus === STATUS_KEY[status.key]"
      (onClick)="statusClick.emit(STATUS_KEY[status.key])" />
  }
</div>
